import { render } from "./AddMediaCheckout.vue?vue&type=template&id=87261dba&scoped=true"
import script from "./AddMediaCheckout.vue?vue&type=script&lang=js"
export * from "./AddMediaCheckout.vue?vue&type=script&lang=js"

import "./AddMediaCheckout.vue?vue&type=style&index=0&id=87261dba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87261dba"

export default script